module.exports = __webpack_public_path__ + "static/media/story-2.915f2bd1.jpeg";